// extracted by mini-css-extract-plugin
export default {"copyLinkToast":"McpYQGgGeJhpisV1ij8J"};